import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Category } from '../../interfaces/category.model';
import { Storage } from '@ionic/storage';

@Injectable()
export class CategoriesProvider {

  categories: Category[];

  constructor(public http: HttpClient, public storage: Storage) {}

  getCategories() {
    return new Promise<Category[]>((resolve, reject) => {
      this.storage.get("categories").then((data:Category[]) => {
        this.categories = data;
        resolve(this.categories);
      });
    });
  }
 
  updateCategoryList(synchroListCategories){
    return new Promise((resolve, reject) => {
      let add = this.addCategories(synchroListCategories);
      let del = this.deleteCategories(synchroListCategories);
      let up = this.updateCategories(synchroListCategories);
      
      Promise.all([add, del, up]).then(data => { 
        this.storage.set("categories", this.categories).then(() => {
          resolve();
        });
      });
    });
  }

  deleteCategories(synchroListCategories) {
    return new Promise((resolve, reject) => {
      let deletedCatList = synchroListCategories.Deleted;

      if(deletedCatList.length > 0) {
        for(let i = 0; i < this.categories.length; i++){
            let cat = this.categories[i];
            if(deletedCatList.indexOf(cat.CategoryId) !== -1){
                this.categories.splice(i, 1);
                i--;
            }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  updateCategories(synchroListCategories){
    return new Promise((resolve, reject) => {
      let updatedCatList = synchroListCategories.Updated;

      if(updatedCatList.length > 0){
        for(let i = 0; i < updatedCatList.length; i++){
          let index = this.categories.findIndex(item => item.CategoryId == updatedCatList[i].CategoryId)
          if(index !== -1){
            this.categories[index] = updatedCatList[i];
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  addCategories(synchroListCategories) {
    return new Promise((resolve, reject) => {
      let addedCatList = synchroListCategories.Added;

      if(addedCatList.length > 0){
        for(let i = 0; i < addedCatList.length; i++){
          let cat = addedCatList[i];
          let found = this.categories.some(item => item.CategoryId == cat.CategoryId);
          if(!found){
              this.categories.push(cat);
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  filterByCategories(selectedCategorie) {
    if(this.categories && this.categories.length > 0){
      return this.categories.filter(item => item.ParentCategoryId == selectedCategorie).sort((a, b) => (a.CategoryIndex - b.CategoryIndex));
    }
    return [];
  }

}



// WEBPACK FOOTER //
// ./src/providers/categories/categories.ts